export class Block {

    name = "";
    key = "";
    rows = [];
}
